import _styled from "styled-components";
var _excluded = ["children", "normalizedTree", "orderedIds", "getTreeNodeProps", "style"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import TreeNode from './TreeNode';
var Tree = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$normalizedTree = _ref.normalizedTree,
    normalizedTree = _ref$normalizedTree === void 0 ? {} : _ref$normalizedTree,
    _ref$orderedIds = _ref.orderedIds,
    orderedIds = _ref$orderedIds === void 0 ? [] : _ref$orderedIds,
    _ref$getTreeNodeProps = _ref.getTreeNodeProps,
    getTreeNodeProps = _ref$getTreeNodeProps === void 0 ? function (treeNodeProps) {
      return treeNodeProps;
    } : _ref$getTreeNodeProps,
    style = _ref.style,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledUl, _extends({
    ref: ref
  }, props, {
    $_css: [{
      padding: 0,
      backgroundColor: theme.colors.white
    }, style]
  }), children || orderedIds.map(function (id) {
    return normalizedTree[id];
  }).map(getTreeNodeProps).map(function (node) {
    return /*#__PURE__*/React.createElement(TreeNode, _extends({
      key: node.id
    }, node));
  }));
});
Tree.displayName = 'Tree';
Tree.propTypes = {
  style: stylePropType,
  className: PropTypes.string,
  children: PropTypes.node,
  orderedIds: PropTypes.array,
  normalizedTree: PropTypes.shape({}),
  getTreeNodeProps: PropTypes.func
};
export default Tree;
var _StyledUl = _styled("ul").withConfig({
  displayName: "Tree___StyledUl",
  componentId: "sc-zcxj8l-0"
})(["", ""], function (p) {
  return p.$_css;
});
//# sourceMappingURL=Tree.js.map